'use strict';

exports.__esModule = true;
exports.ViasDependPromise = undefined;

var _Model = require('./Model');

var _Model2 = _interopRequireDefault(_Model);

var _ViasPromise2 = require('./ViasPromise');

var _ViasPromise3 = _interopRequireDefault(_ViasPromise2);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// ViasPromise that depends on other ViasPromise

var ViasDependPromise = exports.ViasDependPromise = function (_ViasPromise) {
  _inherits(ViasDependPromise, _ViasPromise);

  function ViasDependPromise(dependModel, dependencies, dependExec) {
    _classCallCheck(this, ViasDependPromise);

    var _this = _possibleConstructorReturn(this, _ViasPromise.call(this, dependModel));

    _this.dependencies = dependencies;
    // Function to execute after all the dependencies are ready
    _this.dependExec = dependExec;
    return _this;
  }

  ViasDependPromise.prototype.cacheModel = function cacheModel() {
    // The actual model after all the dependencies are ready
    return this.dependant && this.dependant.model;
  };

  ViasDependPromise.prototype._computeDependant = function _computeDependant() {
    if ((0, _util.viasPromiseState)(this.dependencies).fulfilled) {
      var dependencyValues = (0, _util.viasPromiseValue)(this.dependencies);
      // Final promise to resolve
      this.dependant = this.dependExec(dependencyValues, this.dependencies);
      // Mark every dependenices are ready
      this.ready = true;
    }
  };

  ViasDependPromise.prototype._prepareExec = function _prepareExec() {
    this._computeDependant();
    if (this.ready) {
      if (this.dependant) {
        // Copy final promise attr to itself
        this.shape = this.dependant.shape;
        this._exec = this.dependant._exec;
        this.options = this.dependant.options;
        this.id = this.dependant.id;
        return this;
      } else {
        // Do not do anything if all dependencies are ready but the exec function return nothing
        this.id = 'noop';
        this._exec = function (options, cb) {
          return cb();
        };
      }
    }
  };

  ViasDependPromise.prototype.fulfill = function fulfill() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    // Compare promise with the same key stored in the cache
    // See if all dependencies are the same
    // If no, fulfill the dependences first
    if (this.key && this.promiseCache) {
      var cachedPromise = this.promiseCache[this.key];
      if (cachedPromise && cachedPromise instanceof ViasDependPromise) {
        var identicalDependency = true;
        for (var key in this.dependencies) {
          if (this.dependencies.hasOwnProperty(key)) {
            var dependency = this.dependencies[key];
            if (cachedPromise.dependencies[key].id !== dependency.id) {
              identicalDependency = false;
              break;
            }
          }
        }
        if (identicalDependency) {
          // Dependencies did not changed, they are fulfilled last time, check if it is ready and fulfill the final promise
          this._prepareExec();
          if (this.ready) {
            return _ViasPromise.prototype.fulfill.call(this, options);
          }
        }
      }
      if (cachedPromise && cachedPromise instanceof ViasDependPromise) {
        this.reason = cachedPromise.reason;
        this.value = cachedPromise.value;
        this.meta = cachedPromise.meta;
      }
      this.promiseCache[this.key] = this;
    }

    // Fulfill dependencies first
    this.pending = true;
    (0, _util.asyncEachOf)(this.dependencies, function (promise, key, fCb) {
      var dependencyOptions = {};
      if (options.sync) {
        dependencyOptions.sync = true;
      }
      promise.fulfill(dependencyOptions).onFinish(function (err) {
        return fCb(err);
      });
    }, function (err) {
      if (err) {
        _this2.reason = err;
        _this2.pending = _this2.fulfilled = false;
        _this2.rejected = true;
        return _this2._broadcast();
      }
      _this2._prepareExec();
      return _ViasPromise.prototype.fulfill.call(_this2, options);
    });
    return this;
  };

  return ViasDependPromise;
}(_ViasPromise3.default);

// Speical vias model to handle depend promise


var Depend = new _Model2.default('Depend');

function toRun(dependencies) {
  return {
    run: function (dependExec) {
      return new ViasDependPromise(Depend, dependencies || {}, dependExec);
    }
  };
}

Depend.set = function (dependencies) {
  return toRun(dependencies);
};

exports.default = Depend;


//////////////////
// WEBPACK FOOTER
// ./~/vias/lib/Depend.js
// module id = 228
// module chunks = 15